<template>
  <div class="app--button"></div>
</template>
<script>
export default {};
</script>

<style scoped>
.app--button {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background-color: red;
  border: 1px solid #000;
}
</style>